import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import Analytics from './tools/analytics';

Analytics.preInit();

const root = ReactDOM.createRoot(document.getElementById('react-root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
